
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InjectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"injections"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archived"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_started"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"column_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"device_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"error"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_modified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"method_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"method_override"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"method_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"injection_ul"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"run_time_ms"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preparation_log"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primary_measurement_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sample_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"compoundEstimationErrors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error_type"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"column"},"name":{"kind":"Name","value":"column_snapshot"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"method"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MethodFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"measurements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ulid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"processed_data_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calibration_points"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peak"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apex_time_str"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"device_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"column_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"method_id"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":755}};
    doc.loc.source = {"body":"#import \"../../methods/fragments/MethodFragment.graphql\"\n\nfragment InjectionFragment on injections {\n  archived\n  date_started\n  column_id\n  created\n  description\n  device_id\n  error\n  id\n  last_modified\n  method_id\n  method_override {\n    id\n    method_id\n    injection_ul\n    run_time_ms\n  }\n  name\n  preparation_log\n  primary_measurement_id\n  sample_id\n  vial\n  compoundEstimationErrors {\n    error_type\n  }\n  column: column_snapshot\n  device {\n    id\n    name\n  }\n  method {\n    ...MethodFragment\n  }\n  configuration\n  measurements {\n    id\n    type\n    ulid\n    meta\n    processed_data_url\n    calibration_points(limit: 1) {\n      id\n      peak {\n        id\n        area\n        apex_time_str\n      }\n    }\n  }\n\n  device_id\n  column_id\n  method_id\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../../methods/fragments/MethodFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["InjectionFragment"] = oneQuery(doc, "InjectionFragment");
        
